import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    // Primary color: A deep, authoritative color (e.g., professional blue)
    primary: {
      main: '#004D40', // Deep Teal/Forest Green
      light: '#4d776f',
      dark: '#00251a',
      contrastText: '#ffffff',
    },
    // Secondary color: A vibrant, modern accent color (e.g., sharp orange/yellow)
    secondary: {
      main: '#FFB300', // Amber/Gold
      light: '#ffb333',
      dark: '#b27d00',
      contrastText: '#000000',
    },
    background: {
      default: '#f5f5f5', // Very light gray background for a clean look
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: [
      'Roboto', // Standard modern font
      'sans-serif',
    ].join(','),
    h3: {
      fontWeight: 700,
      letterSpacing: -0.5,
    },
    button: {
      textTransform: 'none', // Professional buttons don't shout in ALL CAPS
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8, // Slightly rounded corners for a softer, modern look
        },
      },
    },
  },
});

export default theme;